// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"a5b7889a","249":"eadaa803","487":"f2b97d5b","586":"7b885a5a"}[chunkId] + ".chunk.css";
};